import { useRef } from "react";
function usePAFormStepperFieldRefs() {
  const nameField = useRef(null);
  const emailField = useRef(null);
  const phoneField = useRef(null);
  const orgField = useRef(null);
  return {
    nameField,
    emailField,
    phoneField,
    orgField
  };
}
export {
  usePAFormStepperFieldRefs
};
